import { notificationPosition } from '@/constants/config'
import { i18n } from '@/setup/i18n-setup'

export const notificationType = {
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
};

export const calculatedSuccess = (value) => {
  return {
    title: i18n.t('notification.calculated-success-title'),
    text: i18n.t('notification.calculated-success-message', { count: value.count}),
    color: 'success',
    position: notificationPosition
  }
}

export const addItemSuccess = (value) => {
  return {
    title: i18n.t('notification.add-item-success-title'),
    text: i18n.t('notification.add-item-success-message', {value}),
    color: 'success',
    position: notificationPosition
  }
}

export const updateItemSuccess = (value) => {
  return {
    title: i18n.t('notification.update-item-success-title'),
    text: i18n.t('notification.update-item-success-message', {value}),
    color: 'success',
    position: notificationPosition
  }
}

export const deleteItemSuccess = (value) => {
  return {
    title: i18n.t('notification.delete-item-success-title'),
    text: i18n.t('notification.delete-item-success-message', {value}),
    color: 'success',
    position: notificationPosition
  }
}

export const info = (value, title) => {
  return {
    title: i18n.t(title ? title : 'notification.general-info-title'),
    text: i18n.t(value ? value : 'notification.general-info-message'),
    color: 'primary',
    position: notificationPosition
  }
}

export const success = (title, message, value) => {
  return {
    title: i18n.t(title ? title : 'notification.general-success-title'),
    text: i18n.t(message ? message : 'notification.general-success-message', {value}),
    color: 'success',
    position: notificationPosition
  }
}


export const warning = (value, title) => {
  return {
    title: i18n.t(title ? title : 'notification.general-warning-title'),
    text: i18n.t(value ? value : 'notification.general-warning-message'),
    color: 'warning',
    position: notificationPosition
  }
}

export const error = (value, title) => {
  return {
    title: i18n.t(title ? title : 'notification.general-error-title'),
    text: i18n.t(value ? value : 'notification.general-error-message'),
    color: 'danger',
    position: notificationPosition
  }
}

export const showStateNotification = (vs, data) => {
  if (data && data.title) {
    //clone state data to local data
    let localData = JSON.parse(JSON.stringify(data));

    vs.notify(localData);
  }
};

export const showLocalNotification = (vs, title, message, type) => {
  if (type === notificationType.SUCCESS) {
    vs.notify(success(title, message));
  } else if (type === notificationType.INFO) {
    vs.notify(info(title, message));
  } else if (type === notificationType.WARNING) {
    vs.notify(warning(title, message));
  } else if (type === notificationType.ERROR) {
    vs.notify(error(title, message));
  }
};

export const successNotification = (vs, title, message) => {
  vs.notify(success(title, message));
};

export const errorNotification = (vs, title, message) => {
  vs.notify(error(title, message));
};

export const serverResponseStatus = (title, data) => {
  const { success, error, message } = data.status
  return {
    title: i18n.t(title ? title : 'notification.general-error-title'),
    text: i18n.t(message ? message : 'notification.general-error-message'),
    color: error ? 'danger' : success ? 'success' : 'primary',
    position: notificationPosition
  }
}

export const serverResponseStatusCustom = (title, data) => {
  const { success, error, message } = data.status
  return {
    title: title,
    text: message,
    color: error ? 'danger' : success ? 'success' : 'primary',
    position: notificationPosition
  }
}
